import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useTransfers(params = {}) {
  return useQuery({
    queryKey: ['cashbox', 'transfers', params],
    queryFn: async () => {
      const { data } = await api.get('/cashbox/transfers', { params });
      return data;
    },
    staleTime: 0
  });
}

export function useCreateTransfer() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/cashbox/transfers', body).then((r) => r.data),
    successMessage: 'تم تنفيذ التحويل',
    onSuccess: async () => {
      // أبطل جميع استعلامات القاصات والتحويلات وأعد جلبها فوراً بدلاً من الانتظار للتركيز.
      await qc.invalidateQueries({ queryKey: ['cashbox'], refetchType: 'active' });
    }
  });
}
